import type { RolePermissionsResponse } from '@common/types/roles';
import axiosInstance from '@/services/axiosInstance';

export async function fetchRolePermissions() {
    const response = await axiosInstance.get<RolePermissionsResponse>('/api/v1/roles/permissions');
    return response.data;
}
